import client from './client';
import {
	formatUserData, getRequestData, IBookLog,
	IBookRegionLog, IUserLog
} from './index';

export default (
	cid: string,
	user: IUserLog,
	book: Omit<IBookLog, 'status'>,
	bookRegion: IBookRegionLog,
	bookLink: string,
	sandbox: Boolean,
) => {
	client.info('click affiliate link', {
		cid,
		context: 'LinkBookRootPage#BookLoginPage#openAffiliateLink',
		book,
		bookRegion,
		link_url: bookLink,
		sandbox,
		...formatUserData(user),
		...getRequestData(),
	});
};
